import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/nathan/Documents/GitHub/wmn-cms-docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "adding-links"
    }}>{`Adding Links`}</h1>
    <p>{`To add or edit a link the CMS has a standard component but there's multiple way of adding depending on the page you're editing.`}</p>
    <h2 {...{
      "id": "the-link-component"
    }}>{`The Link Component`}</h2>
    <p><img alt="Link Component" src={require("../../../public/cms/links/link.png")} /></p>
    <ol>
      <li parentName="ol">{`Add a custom link. This is usualy used for external links.`}</li>
      <li parentName="ol">{`Enter a link title for accessibility. This will appear when a user hovers over the link or uses screen reader software.`}</li>
      <li parentName="ol">{`Target - If the link is going to an external website it's best practice to open it in a new window/tab.`}</li>
      <li parentName="ol">{`Use this section to link to an internal page. the link and title will be automatially populated.`}</li>
      <li parentName="ol">{`Use this button to link to media in the CMS Media library.`}</li>
    </ol>
    <h2 {...{
      "id": "methods-of-adding-links"
    }}>{`Methods of adding links`}</h2>
    <h3 {...{
      "id": "1---rich-text-editor"
    }}>{`1 - Rich text Editor`}</h3>
    <p>{`The Rich Text Editor is an editable block with similer functions to a text editor. On some of the website page you're able to add and edit inline links.`}</p>
    <ol>
      <li parentName="ol">{`Hightlight the text you want linking`}</li>
    </ol>
    <p><img alt="RTE Highlight" src={require("../../../public/cms/links/link-rte-highlight.png")} /></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Click on the link icon in the toolbar
Note - This icon is not available on all Rich Text Editors`}</li>
    </ol>
    <p><img alt="Toolbar icon" src={require("../../../public/cms/links/link-rte-link-toolbar.png")} /></p>
    <h3 {...{
      "id": "2---cms-link-component"
    }}>{`2 - CMS Link Component`}</h3>
    <p>{`Click on the "Add" button`}</p>
    <p><img alt="Related content" src={require("../../../public/cms/links/link-cms-component.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      